import { SOURCE_TYPE_ICON_TYPES } from '@/src/constants/wallet'
import { WalletTransaction } from '@/src/types/wallet'
import { formatCleartripTransactionForDisplay, formatTransactionForDisplay } from '@/src/utils/wallet'
import type { CleartripFormattedTransaction } from '@/src/components/common/wallet/cleartripTransactions/cleartripTransactions'

export const formatFlyinTransactionsForView = (
    transactions: WalletTransaction[],
    t: (key: string, values?: Record<string, any>) => string
) => {
    return transactions.map(txn => {
        const formatted = formatTransactionForDisplay(txn, t)
        const iconType = SOURCE_TYPE_ICON_TYPES[txn.sourceType] || 'card'
        return { ...formatted, iconType }
    })
}

export const formatCleartripTransactionsForView = (
    transactions: WalletTransaction[],
    t: (key: string, values?: Record<string, any>) => string,
    locale?: string
): CleartripFormattedTransaction[] => {
    return transactions.map(txn => {
        const formatted = formatCleartripTransactionForDisplay(txn, t, locale)
        return {
            id: formatted.id,
            source: formatted.source,
            transactionDate: formatted.transactionDate,
            amount: formatted.amount,
            currency: formatted.currency,
            txnType: formatted.txnType
        }
    })
}
